export default "__VITE_ASSET__DlzigK5E__"